import { network } from 'services/network';

import { QueryParams } from 'api/queries/timelineAndDensity.query';

export const ENDPOINT = 'api/bo/getHeatMapSummary';

export const getHeatMapSummary = (params: QueryParams) => {
    return network.post('api/bo/getHeatMapSummary', params).then((response) => {
        return response.data;
    });
};
